export default "__VITE_ASSET__M4azoIGM__"